import { useState, useEffect, useCallback } from 'react';
import api from '@/lib/api';
import { useAuth } from '@/contexts/AuthContext';

// One shared fetch for the menu indicator and the dashboard cards.
let cache = null;
const listeners = new Set();

async function load() {
  try {
    const { data } = await api.get('/parent/internship-alerts');
    cache = data;
  } catch {
    cache = { indicator: false, items: [] };
  }
  listeners.forEach(fn => fn(cache));
  return cache;
}

export function refreshInternshipAlerts() {
  return load();
}

export function useInternshipAlerts() {
  const { user } = useAuth();
  const active = user?.role === 'parent';
  const [alerts, setAlerts] = useState(cache || { indicator: false, items: [] });

  useEffect(() => {
    if (!active) return undefined;
    listeners.add(setAlerts);
    if (cache) setAlerts(cache); else load();
    return () => listeners.delete(setAlerts);
  }, [active]);

  const refresh = useCallback(() => load(), []);
  return active ? { ...alerts, refresh } : { indicator: false, items: [], refresh };
}
